(async () => {
    const { Core } = await importModule('Core');
    const { parseHTML, $clone, $toggleDisplay, $isEmpty } = await importModule('Utils');

    const CN_OPEN = '!open';
    const CN_LOADING = '!loading';
    const CN_EMPTY = '!empty';
    const CN_NO_SCROLL = 'no-scroll';
    const SEL_CART = '[data-drawer-cart]';
    const EL_DRAWER_TRIGGER = 'cart-drawer-trigger';

   function defineTrigger(openDrawer) {
        customElements.define(EL_DRAWER_TRIGGER, class extends Core {
            render() {
                this.addEventListener('click', this._onClick.bind(this))                                                                // or|and replace cart-drawer-trigger with link
            }

            _onClick(e) {
                e.preventDefault();
                openDrawer();
            }
        })
    }

    function selectItemByKey(key, src) {
        return src.querySelector(`[data-item-key="${key}"]`);
    }

    customElements.define('cart-drawer', class extends Core {
        subscriptions = {
            'drawer:open':  '_open',
            'modal:open':  '_close',
            'cart:update': '_update',
            'drawer:item-loading': '_itemLoading'
        }

        elements = {
            close: '[data-close]',
            closeButton: '[data-close-button]',
            backdrop: '[data-backdrop]',
            productLoadingTemplate: '[data-product-loading-template]',
            dynamicParts: '*[data-dynamic]'
        }

        async render() {
            await customElements.whenDefined('cart-provider');
            defineTrigger(this._open.bind(this));
            this.publish('cart:add-feature', { feature: 'drawer' });
            this._handleEvents();
            this._handleCloseClick();
        }

        _handleEvents() {
            this.subscribe('cart:update', { global: true });
            this.subscribe('drawer:open', { global: true });
            this.subscribe('modal:open', { global: true });
            this.subscribe('drawer:item-loading');
        }

        _handleCloseClick() {
            this.$close.addEventListener('click', this._close.bind(this));
            this.$backdrop.addEventListener('click', this._close.bind(this));
            this.$closeButton.addEventListener('click', this._close.bind(this));
        }

        _close() {
            this.classList.remove(CN_OPEN);
            document.body.classList.remove(CN_NO_SCROLL);
        }

        _open() {
            this.publish('modal:close');
            this.classList.add(CN_OPEN);
            // TEMP: it's overlapping with 'modal:close' event
            setTimeout(() => {
                document.body.classList.add(CN_NO_SCROLL);
            }, 50);
        }

        _itemLoading({ key }) {
            const $upadtingItem = selectItemByKey(key, this);
            $upadtingItem
                ?.append($clone(this.$productLoadingTemplate))
        }

        async _update({ drawer, meta }) {
            if (!drawer?.section) return; // sanity check from provider


            this.$updatedDoc = parseHTML(drawer.section);
            this._updateDynamicParts();
            this._toggleEmpty(meta?.count);

            if(drawer.open) {
                this._open();
            }
        }

        _updateDynamicParts() {
            const parts = Array.from(this.$updatedDoc.querySelectorAll(this.elements.dynamicParts));
            parts.map(part => {
                const match = this.$dynamicParts.find(item => item.dataset.dynamic === part.dataset.dynamic);
                match.replaceChildren(...part.childNodes);
            })
        }

        _toggleEmpty(count) {
            this.classList.toggle(CN_EMPTY, !count);
        }

    })

    const ATTR_VARIANT_ID = 'variant-id';
    const ATTR_SELLING_PLAN_ID = 'selling-plan-id';

    customElements.define('cart-drawer-qty-button', class extends Core {
        render() {
            this.addEventListener('click', this._handleClick.bind(this), { once: true });
        }

        _handleClick() {
            this.publish('cart:qty-update', {
                id: this.variantId,
                quantity: this.value,
                selling_plan: this.sellingPlanId,
                src: 'drawer'
            });


            this.publish('drawer:item-loading', {
                key: this.key
            })
        }

        disconnect() {
            this.removeEventListener('click', this._handleClick.bind(this), false);
        }

        get variantId() {
            return this.getAttribute(ATTR_VARIANT_ID);
        }

        get sellingPlanId() {
            return this.getAttribute(ATTR_SELLING_PLAN_ID) || '';
        }

        get value() {
            return this.getAttribute('set-value');
        }

        get key() {
            return this.getAttribute('key');
        }
    });
})();
